import { render, staticRenderFns } from "./unfollowLog.vue?vue&type=template&id=79bf357c&scoped=true&"
import script from "./unfollowLog.vue?vue&type=script&lang=js&"
export * from "./unfollowLog.vue?vue&type=script&lang=js&"
import style0 from "./unfollowLog.vue?vue&type=style&index=0&id=79bf357c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bf357c",
  null
  
)

export default component.exports